// confirms.js
import { reactive } from 'vue'

export const confirmState = reactive({
  show: false,
  title: 'Are you sure?',
  message: '',
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  noCancelButton: false,
  noCancelIcon: false,
  noIcon: false,
  iconClass: 'question-circle',
  iconColor: 'warning',
  backdrop: true,

  // NEW (optional form support)
  form: null,          // { fields: [{ key, label, type, placeholder, required }], initialValues? }
  formValues: {},      // reactive values for the modal inputs
  returnPayload: false // if true -> resolve({ ok, values }); else -> resolve(ok)
})

let resolver = null

function resetDefaults() {
  Object.assign(confirmState, {
    title: 'Are you sure?',
    message: '',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    noCancelButton: false,
    noCancelIcon: false,
    noIcon: false,
    iconClass: 'question-circle',
    iconColor: 'warning',
    backdrop: true,

    // NEW defaults
    form: null,
    formValues: {},
    returnPayload: false,
  })
}

export function openConfirm(options = {}) {
  resetDefaults()

  // Apply options first
  Object.assign(confirmState, {
    ...options,
    show: true,
  })

  // If a form is provided, init values (but do NOT force return type unless asked)
  if (confirmState.form?.fields?.length) {
    const initial = confirmState.form.initialValues || {}
    const values = {}
    for (const f of confirmState.form.fields) {
      values[f.key] = initial[f.key] ?? ''
    }
    confirmState.formValues = values

    // Only change what the caller receives when explicitly requested
    // (so existing callers keep getting a boolean)
    confirmState.returnPayload = options.returnPayload === true
  }

  return new Promise((resolve) => { resolver = resolve })
}

// Now supports optional payload (keeps old calls working)
export function resolveConfirm(ok, payload) {
  confirmState.show = false

  if (resolver) {
    if (confirmState.returnPayload) {
      resolver({ ok: !!ok, values: payload ?? { ...confirmState.formValues } })
    } else {
      resolver(!!ok)
    }
    resolver = null
  }

  // clean up
  confirmState.form = null
  confirmState.formValues = {}
  confirmState.returnPayload = false
}
